processFragments